/**
 * OpenAPI
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BatchAuftragCreateOptionen { 
    ausfuehrungsdatum?: string;
    periodizitaet?: BatchAuftragCreateOptionen.PeriodizitaetEnum;
    prioritaet?: BatchAuftragCreateOptionen.PrioritaetEnum;
    format?: BatchAuftragCreateOptionen.FormatEnum;
    email1?: string;
    email2?: string;
    email3?: string;
    auftragsTitel?: string;
    auftragsBeschreibung?: string;
}
export namespace BatchAuftragCreateOptionen {
    export type PeriodizitaetEnum = 'EINMALIG' | 'WOECHENTLICH' | 'MONATLICH';
    export const PeriodizitaetEnum = {
        EINMALIG: 'EINMALIG' as PeriodizitaetEnum,
        WOECHENTLICH: 'WOECHENTLICH' as PeriodizitaetEnum,
        MONATLICH: 'MONATLICH' as PeriodizitaetEnum
    };
    export type PrioritaetEnum = 'NORMAL' | 'DRINGEND';
    export const PrioritaetEnum = {
        NORMAL: 'NORMAL' as PrioritaetEnum,
        DRINGEND: 'DRINGEND' as PrioritaetEnum
    };
    export type FormatEnum = 'XML' | 'CSV' | 'XML_HTML';
    export const FormatEnum = {
        XML: 'XML' as FormatEnum,
        CSV: 'CSV' as FormatEnum,
        XML_HTML: 'XML_HTML' as FormatEnum
    };
}


